module.exports = __webpack_public_path__ + "static/letian-48592d831c5df3577b8b6817e190653a.jpg";